export const LOAD_LEASING_EXPENSES_STARTED = "LOAD_LEASING_EXPENSES_STARTED";
export const LOAD_LEASING_EXPENSES_SUCCESS = "LOAD_LEASING_EXPENSES_SUCCESS";
export const LOAD_LEASING_EXPENSES_FAILED = "LOAD_LEASING_EXPENSES_FAILED";
export const LEASING_EXPENSES_UPDATED = "LEASING_EXPENSES_UPDATED";
